module.exports = __webpack_public_path__ + "static/noticias-20--9fd39714bf3a352bbb922feaf20fe1fe.jpg";